// extracted by mini-css-extract-plugin
export default {"sidebar":"AdminSidebar_sidebar__cfiAL","sidebarOverlay":"AdminSidebar_sidebarOverlay__70LSg","navLink":"AdminSidebar_navLink__4McxV","active":"AdminSidebar_active__etWUP"};